import React from 'react';
import { cn } from '@ui/lib/utils';

interface ListProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  spacing?: 'none' | 'sm' | 'md' | 'lg';
  variant?: 'default' | 'bordered' | 'separated';
}

interface ListItemProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

const spacingClasses = {
  none: '',
  sm: 'space-y-1',
  md: 'space-y-2',
  lg: 'space-y-4',
};

export function List({ children, spacing = 'none', variant = 'default', className, ...props }: ListProps) {
  return (
    <div
      className={cn(
        variant === 'default' && spacingClasses[spacing],
        variant === 'bordered' && 'border border-gray-200 rounded-lg overflow-hidden divide-y divide-gray-200',
        variant === 'separated' && 'divide-y divide-gray-200',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function ListItem({ children, className, ...props }: ListItemProps) {
  return (
    <div
      className={cn(
        // Default padding can be overridden
        'p-2 hover:bg-gray-50 transition-colors',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
